import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

import config from "./key.json";

const firebaseConfig = config;

const firebaseApp = initializeApp(firebaseConfig);
const db = getFirestore(firebaseApp);

export default db;
